// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-md + .item-inner ion-label {
  margin-left: 14px;
}

.checkbox-md {
  padding-left: 0px;
}

.item-checkbox .label {
  font-size: 1.5rem;
  color: #3D3D3D;
  font-weight: 400;
}

.text-input[disabled] {
  opacity: 0.6;
}

.labels {
  opacity: 100% !important;
}

.autoaddress-container {
  z-index: 9999;
  margin-top: -6px !important;
  right: 5px !important;
  width: 92%;
  margin-left: 17px;
  border: 1px solid #ccc;
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  max-height: 50vh;
}
@media screen and (max-width: 768px) {
  .autoaddress-container {
    max-height: 35vh;
  }
}
.autoaddress-container .autoaddress-container {
  margin-top: 0 !important;
}
.autoaddress-container .autoaddress-items-med a {
  font-size: 1rem;
  cursor: pointer;
  padding-left: 8px !important;
}

ion-list.no-padding {
  padding-top: 0px;
  padding-bottom: 0px;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

ion-toolbar {
  display: block !important;
}

@media screen and (max-width: 550px) {
  ion-title {
    font-size: 13px !important;
  }
}
ion-toolbar,
.toolbar-container {
  height: 42px;
}

ion-ripple-effect {
  color: var(--ion-color-light);
}

ion-title {
  text-align: center;
  font-size: 20px;
  font-weight: 550 !important;
  line-height: 44px;
  transform: translateY(-8px);
}
@media screen and (max-width: 550px) {
  ion-title {
    font-size: 15px;
  }
}
@media screen and (max-width: 350px) {
  ion-title {
    font-size: 14px;
  }
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/personal-information/personal-information.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,wBAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;AACJ;AAAI;EAXJ;IAYM,gBAAA;EAGJ;AACF;AADI;EACI,wBAAA;AAGR;AACQ;EACI,eAAA;EACA,eAAA;EACA,4BAAA;AACZ;;AAGA;EACI,gBAAA;EACA,mBAAA;AAAJ;;AAYA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AATJ;;AAYA;EACI,yBAAA;AATJ;;AAWA;EACI;IACI,0BAAA;EARN;AACF;AAWA;;EAEE,YAzBqB;AAgBvB;;AAYA;EACE,6BAAA;AATF;;AAYA;EACE,kBAAA;EACA,eAjCwB;EAkCxB,2BAjC0B;EAkC1B,iBAjC0B;EAkC1B,2BAAA;AATF;AAWE;EAPF;IAQI,eApC6B;EA4B/B;AACF;AAUE;EAXF;IAYI,eAvCgC;EAgClC;AACF;;AAUA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAPF","sourcesContent":[".checkbox-md + .item-inner ion-label {\n    margin-left: 14px;\n}\n\n.checkbox-md {\n    padding-left: 0px;\n}\n\n.item-checkbox .label {\n    font-size: 1.5rem;\n    color: #3D3D3D;\n    font-weight: 400;\n}\n\n.text-input[disabled] {\n    opacity: 0.6;\n}\n\n.labels {\n    opacity: 100%!important;\n}\n\n.autoaddress-container {\n    z-index: 9999;\n    margin-top: -6px !important;\n    right: 5px !important;\n    width: 92%;\n    margin-left: 17px;\n    border: 1px solid #ccc;\n    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, .2);\n    overflow-y:auto;\n    -webkit-overflow-scrolling: touch;\n    max-height: 50vh ;\n    @media screen and (max-width: 768px) {\n      max-height: 35vh;\n    }\n\n    .autoaddress-container {\n        margin-top: 0 !important;\n    }\n\n    .autoaddress-items-med {\n        a {\n            font-size: 1rem;\n            cursor: pointer;\n            padding-left: 8px !important;\n        }\n    }\n}\nion-list.no-padding{\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n\n//Navbar style\n$custom-navbar-height: 42px;\n$custom-navbar-font-size: 20px;\n$custom-navbar-font-weight: 550!important;\n$custom-navbar-line-height: 44px;\n$custom-navbar-font-size-mobile: 15px;\n$custom-navbar-font-size-mobile-xs: 14px;\n$custom-navbar-text-transform: uppercase;\n\n.text-overflow {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\nion-toolbar{\n    display: block !important;\n}\n@media screen and (max-width: 550px){\n    ion-title {\n        font-size: 13px !important;\n    }\n}\n\nion-toolbar,\n.toolbar-container {\n  height: $custom-navbar-height;\n}\n\nion-ripple-effect {\n  color: var(--ion-color-light);\n}\n\nion-title {\n  text-align: center;\n  font-size: $custom-navbar-font-size;\n  font-weight: $custom-navbar-font-weight;\n  line-height: $custom-navbar-line-height;\n  transform: translateY(-8px);\n\n  @media screen and (max-width: 550px) {\n    font-size: $custom-navbar-font-size-mobile;\n  }\n\n  @media screen and (max-width: 350px) {\n    font-size: $custom-navbar-font-size-mobile-xs;\n  }\n}\n\n.text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
